/**
 * One demo photo in an arm B scene (#1070): AVIF, then WebP, then a WebP
 * `<img>`, each with every committed width so the browser picks by `sizes`.
 *
 * Always decorative — it sits inside a scene that is either one `role="img"`
 * with its own label or `aria-hidden` — so the `alt` is empty. Every slot is
 * below the fold, so the photo loads lazily and decodes off the main thread;
 * its explicit width and height give it a ratio before it arrives.
 */
import { DEMO_IMAGE_SIZE, DEMO_IMAGE_WIDTHS, demoImageSrc, demoSrcSet } from "./homepageDemo";

/** The width a browser without `srcset` support falls back to. */
const FALLBACK_WIDTH = DEMO_IMAGE_WIDTHS[1];

/**
 * @param {object} props
 * @param {import("./homepageDemo").DemoScene} props.scene - the photo.
 * @param {string} props.sizes - the slot's rendered width, as a `sizes` value.
 * @param {string} [props.className] - class for the `<img>`, which the slot sizes.
 */
const DemoPicture = ({ scene, sizes, className = "figma-b__photo" }) => (
  <picture className="figma-b__picture" data-demo-scene={scene}>
    <source type="image/avif" srcSet={demoSrcSet(scene, "avif")} sizes={sizes} />
    <source type="image/webp" srcSet={demoSrcSet(scene, "webp")} sizes={sizes} />
    <img
      className={className}
      src={demoImageSrc(scene, FALLBACK_WIDTH, "webp")}
      srcSet={demoSrcSet(scene, "webp")}
      sizes={sizes}
      width={DEMO_IMAGE_SIZE.width}
      height={DEMO_IMAGE_SIZE.height}
      alt=""
      loading="lazy"
      decoding="async"
    />
  </picture>
);

export default DemoPicture;
